declare var __env;
const env: any = __env || {};
export const environment = {
  production: true,
  rapido_dashboard: 'https://dash.staging.plectrum.dev',
  payroll_dashboard: 'https://payroll.staging.plectrum.dev',
  server: 'https://profile-dashboard-api.staging.plectrum.dev',
  googleAccountKey: '924479965589-7e64mcomrnv5ekb5gr1kjdja488qfp8f.apps.googleusercontent.com',
  oauth: 'https://profile.staging.plectrum.dev/login',
  validReferrer: [
    'http://payroll-dev.rapido.bike.s3-website.ap-south-1.amazonaws.com',
    'https://profile.staging.plectrum.dev',
    'https://payroll.staging.plectrum.dev',
    'http://localhost:4200',
    'http://supply-dev.rapido.bike',
    'http://supply-dev.rapido.bike:7500',
    'https://profiles.rapido.bike',
  ],
  trackUrl: 'https://trk.staging.plectrum.dev/track/',
  s3RapidoUrl: 'http://rapido-file-store.svc.staging.internal/file',
  servicesAllowedToArrive: env.servicesAllowedToArrive,
  servicesAllowedToDrop: env.servicesAllowedToDrop,
  tollAdjustmentEnabledModeIds: env.tollAdjustmentEnabledModeIds,
  FRESH_DESK_TICKETS_URL: env.FRESH_DESK_TICKETS_URL,
  CAPTAIN_ISSUES_SUB_REASONS: env.CAPTAIN_ISSUES_SUB_REASONS,
  CAPTAIN_TICKET_DISPOSITIONS: env.CAPTAIN_TICKET_DISPOSITIONS,
  autoEarningsCityConfig:env.autoEarningsCityConfig,
  autoFlatCommissionCities:env.autoFlatCommissionCities,
  googleMapsApiKey: env.googleMapsApiKey,
};
